import { ReactElement } from 'react';
import { isUserPermitted } from '../../../../auth/components/UserRoleGuard/utils';
import { INTERNAL_USER_ROLES } from '../../../constants';
import { HomePageCarousel } from '../HomePageCarousel';
import { Hero } from '../Hero';
import { HeroWebex } from '../HeroWebex';

export type HomeHeroSectionProps = {
  userRoles: UserRole[];
};

export const HomeHeroSection = ({
  userRoles,
}: HomeHeroSectionProps): ReactElement => {
  const isUser = isUserPermitted(userRoles, ['ROLE_USER']);
  const isInternalUser = isUserPermitted(userRoles, INTERNAL_USER_ROLES);

  return isInternalUser ? (
    <HomePageCarousel
      slides={[<Hero key={0} userHasAccess={isUser} />, <HeroWebex key={1} />]}
    />
  ) : (
    <Hero key={0} userHasAccess={isUser} />
  );
};
